<template>
  <div id="verify-email">
    <p>{{ $t('moreStep') }}</p>
    <p>{{ $t('verifyEmail') }}<span class="link">{{ email }}</span>{{ $t('enjoy') }}<span class="blod">{{ $t('freeTrial') }}</span></p>
    <spinner :show="loading" class="spinner-component"></spinner>
    <p class="error-msg">{{ errorMsg }}</p>
    <p v-if="!loading"><button @click="sendVerificationCodeToEmail">{{ $t('verifyBtn') }}</button></p>
    <p class="skip-verify"><router-link class="link" to="/dashboard">{{ $t('skipVerify') }}</router-link>{{ $t('checkAccount') }}</p>
  </div>
</template>

<script>
  import locales from './lang'
  import Spinner from '../../components/Spinner.vue'

  export default {
    name: 'verify-email',
    locales,
    components: {Spinner},
    data: function () {
      return {
        loading: false,
        errorMsg: ''
      }
    },
    computed: {
      email() {
        return this.$store.state.user.email
      }
    },
    methods: {
      sendVerificationCodeToEmail() {
        this.loading = true
        this.$http.post('api/verification/email', {
          email: this.email,
          type: 'binding'
        }).then((response) => {
          this.loading = false
          if (response.data.code === 0) {
            this.$store.commit('setShowVerifyForm', true)
          } else {
            this.errorMsg = response.data.message
          }
        })
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/mixins/button";
  @import "../../assets/scss/mixins/gradient";

  * {
    padding: 0;
    margin: 0;
  }

  #verify-email {
    p {
      font-size: .2rem;
      letter-spacing: 1.17px;
      line-height: 30px;
      &:first-child {
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 60px;
      }
      .link {
        color: #416CF8;
      }
      .blod {
        font-size: .32rem;
        letter-spacing: 1.17px;
        font-weight: 600;
      }
      &.error-msg {
        color: #FC5A5A;
        font-size: .16rem;
      }
    }
    button {
      width: 400px;
      height: 54px;
      line-height: 54px;
      background-image: linear-gradient(125deg, #416CF8 0%, #EC55FF 100%);
      border-radius: 100px;
      border: none;
      font-size: 18px;
      font-weight: 600;
      color: #FFFFFF;
      margin: .6rem auto;
    }
    .spinner-component {
      margin: .55rem auto .4rem auto;
    }
  }

  @mixin pc-style() {
  }

  @mixin phone-style() {
    #verify-email {
      p{
        font-size: .14rem;
        letter-spacing: 0.5px;
        line-height: .24rem;
        &:first-child {
          font-size: 18px;
          margin-bottom: 24px;
        }
        .blod {
          display: block;
          margin-top: 8px;
          font-size: .24rem;
          line-height: .32rem;
        }
        &.skip-verify {
          a {
            display: block;
            margin-bottom: 8px;
          }
        }
      }
      button {
        width: 260px;
        height: 49px;
        line-height: 49px;
        font-size: 16px;
        margin: 0.4rem auto;
      }
    }
  }

  @media (min-width: 768px) {
    @include pc-style()
  }

  @media (max-width: 767px) {
    @include phone-style()
  }
</style>



// WEBPACK FOOTER //
// VerifyEmail.vue?34634f48